import React from "react";
import background from "../../../images/branding/meeting-background.png";
import { useWhiteLabel } from "../../../context/WhiteLabelContext";
import RLinkLogo from "../../common/RLinkLogo";

const ConfLeftPanel = () => {
  const { branding, loading } = useWhiteLabel();

  // Don't show the logo until whitelabel loading is complete
  if (loading) {
    return (
      <div
        className="flex flex-col lg:w-[80%] w-full sm:h-[180px] lg:min-h-screen justify-between lg:bg-cover lg:bg-center lg:bg-no-repeat"
        style={{ backgroundImage: `url(${background})` }}
      />
    );
  }

  return (
    <div
      className="flex flex-col lg:w-[80%] w-full sm:h-[180px] lg:min-h-screen justify-between lg:bg-cover lg:bg-center lg:bg-no-repeat"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="relative ml-0 sm:ml-[10%] sm:mt-[5%] md:mt-[0%] lg:mt-[10%] md:ml-[8%] lg:ml-[10%] flex flex-col h-[80%]">
        <div className="sm:mt-[5%] md:mt-[15%] mb-4 sm:mb-6 md:mb-8">
          <RLinkLogo
            size="xl"
            companyLogo={branding.companyLogo}
            companyName={branding.companyName}
          />
        </div>
        <div className="absolute bottom-[15vh] left-0 md:block text-white sm:text-2xl md:text-7xl font-bold mb-2 sm:mb-4 md:mb-6 leading-tight opacity-20">
          Meet.
          <br className="hidden lg:block" /> Earn.
          <br className="hidden lg:block" /> Repeat.
        </div>
      </div>
    </div>
  );
};

export default ConfLeftPanel;
